import { useEffect, useState } from 'react';
import { Button } from '../../components';

type Theme = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'srp:theme';

function readStoredTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'light' || stored === 'dark' ? stored : 'system';
}

function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  // "system" remove o atributo e deixa o `prefers-color-scheme` decidir,
  // conforme os tokens em tokens.css.
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
}

const LABELS: Record<Theme, string> = {
  system: 'Tema do sistema',
  light: 'Tema claro',
  dark: 'Tema escuro',
};

const NEXT: Record<Theme, Theme> = { system: 'light', light: 'dark', dark: 'system' };

/**
 * Preferência de tema é a única coisa guardada no navegador — e é preferência
 * de exibição, não credencial. Nenhum dado de sessão vai para `localStorage`
 * (RNF-F09).
 */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>('system');

  useEffect(() => {
    const stored = readStoredTheme();
    setTheme(stored);
    applyTheme(stored);
  }, []);

  const cycle = (): void => {
    const next = NEXT[theme];
    setTheme(next);
    applyTheme(next);
    if (next === 'system') localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, next);
  };

  return (
    <Button variant="ghost" size="sm" onClick={cycle} title={LABELS[theme]}>
      <span aria-hidden="true">{theme === 'dark' ? '◐' : theme === 'light' ? '☀' : '◑'}</span>
      <span className="sr-only">{LABELS[theme]} — clique para alternar</span>
    </Button>
  );
}
